<script lang="ts">
	// services
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	//Design system components
	import { IconButton, Input } from '@Shelly/shelly-design-system';
	import { getNumberInputConfig } from '../helpers/number_input_helpers';

	const dispatch = createEventDispatcher();
	export let value,
		error,
		hysteresis = false,
		icon = 'fas fa-temperature-high',
		allowedDigAfterPoint: Number | undefined,
		inputClasses = '';

	const inputId = `decrease-increase-input-${Math.random().toString(36).substr(2, 9)}`;

	let output;

	$: {
		error = isNaN(+value)
			? $format('scene_invalid_format_err_toast', {
					default: 'Invalid format. Please, fill out fields properly.',
				})
			: error;
	}

	function handleThresholdValue(type, value) {
		if (isNaN(value)) {
			console.error('Invalid value:', value);
			return;
		}

		if (type === 'plus') {
			output = Number(+value + (hysteresis ? 0.1 : 1));
		} else {
			output = Number(+value - (hysteresis ? 0.1 : 1));
		}
		output = Number(output.toFixed(1));
		dispatch('output', output);
	}

	function handleInputValidation(e) {
		if (typeof e.target['value'] === 'undefined') {
			return;
		}

		const inputValue = e.target['value'];
		if (isNaN(inputValue)) {
			console.error('Invalid input value:', inputValue);
			return;
		}

		if (allowedDigAfterPoint === undefined) {
			output = e.target['value'];
			dispatch('output', output);
			return;
		}
		//stop writing when there are more than allowed symbols after decimal point

		const decimalIndex = inputValue.indexOf('.');
		if (
			typeof allowedDigAfterPoint !== 'undefined' &&
			decimalIndex !== -1 &&
			inputValue.length - decimalIndex - 1 > Number(allowedDigAfterPoint)
		) {
			e.target['value'] = inputValue.slice(0, decimalIndex + allowedDigAfterPoint + 1);
		}

		output = e.target['value'];
		dispatch('output', output);
	}
</script>

<slot name="description" />

<div class="d-flex">
	<IconButton
		icon="fas fa-minus"
		aria-label={$format('button_decrease_value', {
			default: 'Decrease value',
		})}
		on:click={() => handleThresholdValue('minus', value)}
	/>
	<Input
		{...getNumberInputConfig()}
		class="width-md-s width-sm-full mr-s ml-s {inputClasses}"
		id={inputId}
		aria-label={$format('input_threshold_value', {
			default: 'Threshold value',
		})}
		{icon}
		{error}
		bind:value
		on:input={(e) => {
			handleInputValidation(e);
		}}
	/>
	<IconButton
		icon="fas fa-plus"
		aria-label={$format('button_increase_value', {
			default: 'Increase value',
		})}
		on:click={() => handleThresholdValue('plus', value)}
	/>
</div>
